export default __webpack_public_path__ + "static/media/notification_notice_icon.51e45add.svg";